<p class="title">Local charity needs</p>
{#if needs.length > 0}
  <table class="table is-fullwidth is-hoverable is-flex-grow-1">
    <tbody>
      {#each needs as need}
        <tr>
          <td style="min-width:100px;">
            <div>
              <a href={$url('../need/' + need.id)}>{need.data.title}</a>
            </div>
            <div>
              {need.data.charityDetails.name}
            </div>
          </td>
          <td>
            {#if need.data.location}
              <span class="has-text-grey-light" style="white-space: nowrap;">
                {businessLocation
                  ? getDistance(
                      {
                        latitude: need.data.location.point.latitude,
                        longitude: need.data.location.point.longitude
                      },
                      {
                        latitude: businessLocation.latitude,
                        longitude: businessLocation.longitude
                      }
                    )
                  : ''}
              </span>
            {/if}
          </td>
        </tr>
      {/each}
    </tbody>
  </table>
{:else}
  <table
    class="table is-fullwidth is-hoverable is-flex is-flex-grow-1 is-justify-content-center is-align-items-center">
    <tbody>
      <tr>
        <td style="min-width:100px;">
          <div
            class="is-flex is-flex-direction-row align-items is-align-items-center has-text-centered"
            style="height:60px;">
            <p>There are currently no charity needs in the local area.</p>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
{/if}

<p class="has-text-grey-light has-text-centered">
  <a href={$url('../needs')}>View all 
  local charity needs</a>
</p>

<script lang="ts">
  import { url, goto } from '@sveltech/routify';
  import { appState } from '../../../../lib/appState';
  import { geoQuery } from '../../../../lib/geo';
  import geoDist from 'geo-dist';

  let firebase = window.firebase;

  let localNeeds: Need_v1_Doc[];

  $: businessLocation = $appState.company?.location;

  $: needs = localNeeds
    ? localNeeds.filter((item) => item.data.status === 'published')
    : [];


  $: if ($appState.company?.location) {
    getNeeds($appState.company.location);
  }

  async function getNeeds(location: GeoPoint) {
    const distance = 10;

    localNeeds = await geoQuery(
      firebase.firestore().collection('needs_v1').where('status', '==', 'published'),
      'location.point',
      location.longitude,
      location.latitude,
      distance
    );
  }

  function getDistance(point1: GeoPoint, point2: GeoPoint) {
    try {
      console.log([point1, point2]);
      const km = geoDist(
        point1.latitude,
        point1.longitude,
        point2.latitude,
        point2.longitude
      );
      console.log(km);
      const miles = km * 0.6213712; // miles
      if (miles < 1) {
        return '< 1 mile';
        // } else if (miles < 4.5) {
        //   return Number.parseFloat(miles).toFixed(1) + " miles away";
      } else {
        console.log(Math.round(miles).toString(10) + ' miles');
        return Math.round(miles).toString(10) + ' miles';
      }
    } catch (err) {
      console.log(err);
    }
  }
</script>
